import React, { useState } from "react";
import TextInputLabelHookForm from "../../../../../components/TextInputLabelHookForm";
import { useFormContext } from "react-hook-form";
import { IExpenseAccount } from "../type";
import { editStateExpenseAccount } from "../atoms/atoms";
import { useRecoilValue } from "recoil";
import CheckBoxLabelHookForm from "components/CheckBoxLabelHookForm";

export const ExpenseAccountDetails = (props: {
  setChanges: React.Dispatch<React.SetStateAction<boolean>>;
  data: IExpenseAccount | undefined;
}) => {
  // Props drilled
  const { data, setChanges } = props;

  // Recoil Hook
  const edit = useRecoilValue(editStateExpenseAccount);

  // Form Functions
  const { register } = useFormContext();
  const formMethods = useFormContext();

  // Local Hooks
  const [expenseAccountInput, setexpenseAccountInput] = useState(data?.expenseAccount || "");
  const [expenseDescriptionInput, setexpenseDescriptionInput] = useState(data?.description || "");
  const [checkBoxChanges, setCheckBoxChanges] = useState(data?.isActive);
  
  return (
    <>
      <div className="bg-bgDB">
        <div className="m-2 bg-white shadow-lg h-full">
          <div className="grid grid-cols-1 md:grid-cols-4 mx-3 pb-2 gap-2 gap-x-2 py-2 place-items-center">
            <div className="my-1 mx-2">
              <TextInputLabelHookForm
                name="expenseAccount"
                label="Expense Account"
                type="text"
                onChange={(e) => {
                  setexpenseAccountInput(e.target.value);

                  if (
                    e.target.value.trim() === "" ||
                    expenseDescriptionInput.trim() === "" ||
                    (e.target.value === data?.expenseAccount &&
                      expenseDescriptionInput.trim() === data?.description &&
                      checkBoxChanges == data?.isActive)
                  ) {
                    setChanges(false);
                  } else {
                    setChanges(true);
                  }
                  e.target.value = e.target.value.replace(/\s+/g, " ");
                }}
                required={true}
                className={
                  formMethods.formState.errors.expenseAccount &&
                  formMethods.formState.errors.expenseAccount.message &&
                  "border-2 border-red-500 col-span-2 "
                }
                register={formMethods.register("expenseAccount", {
                  required: {
                    value: true,
                    message: "Required Field",
                  },
                })}
                maxLength={255}
              />
            </div>

            <div className="my-1 mx-2">
              <TextInputLabelHookForm
                name="description"
                label="Description"
                type="text"
                onChange={(e) => {
                  setexpenseDescriptionInput(e.target.value);

                  if (
                    e.target.value.trim() === "" ||
                    expenseAccountInput.trim() === "" ||
                    (e.target.value === data?.description &&
                      expenseAccountInput.trim() === data?.expenseAccount &&
                      checkBoxChanges == data?.isActive)
                  ) {
                    setChanges(false);
                  } else {
                    setChanges(true);
                  }
                  e.target.value = e.target.value.replace(/\s+/g, " ");
                }}
                required={true}
                className={
                  formMethods.formState.errors.description &&
                  formMethods.formState.errors.description.message &&
                  "border-2 border-red-500 col-span-2 "
                }
                register={formMethods.register("description", {
                  required: {
                    value: true,
                    message: "Required Field",
                  },
                })}
                maxLength={255}
              />
            </div>

            {edit && (
              <div className="my-1 mx-2">
                <CheckBoxLabelHookForm
                  name="isActive"
                  label={
                    checkBoxChanges
                      ? "Uncheck to Deactivate"
                      : "Check to Activate"
                  }
                  type="checkbox"
                  validation={{
                    required: {
                      value: false,
                      message: "Required Field",
                    },
                  }}
                  onClick={(e) => {
                    setCheckBoxChanges(e.target.checked);

                    if (
                      expenseAccountInput?.trim() === "" ||
                      expenseDescriptionInput?.trim() === "" ||
                      (e.target.checked === data?.isActive &&
                        expenseAccountInput == data?.expenseAccount)
                    ) {
                      setChanges(false);
                    } else {
                      setChanges(true);
                    }
                  }}
                  register={register}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ExpenseAccountDetails;
